// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"qw","modify_order":"rw","modify_order_header":"sw","product_details_form_wrapper":"tw","c_wrapper":"uw","save_button":"vw","title":"ww","modify_order_title_wrapper":"xw","note":"yw","buttons_wrapper":"zw"};
    if(module.hot) {
      // 1738064238372
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  